import { motion } from "framer-motion";
import { FaWhatsapp, FaTiktok, FaXTwitter, FaSnapchat, FaTelegram } from "react-icons/fa6";
import { Mail } from "lucide-react";
import { WHATSAPP, EMAIL, platforms } from "@/data/content";

const platformUrl = (id) => platforms.find((p) => p.id === id)?.url;

const socials = [
  {
    id: "whatsapp",
    href: `https://wa.me/${WHATSAPP}`,
    label: "WhatsApp",
    Icon: FaWhatsapp,
    className:
      "bg-emerald-500 text-white hover:bg-emerald-600 shadow-emerald-500/30",
  },
  {
    id: "email",
    href: `mailto:${EMAIL}`,
    label: "Email",
    Icon: Mail,
    className:
      "bg-slate-950 text-white hover:bg-slate-800 shadow-slate-900/30 dark:bg-slate-100 dark:text-slate-950 dark:hover:bg-white",
  },
  {
    id: "tiktok",
    href: platformUrl("tiktok"),
    label: "TikTok",
    Icon: FaTiktok,
    className:
      "bg-black text-white hover:bg-neutral-800 shadow-black/30 dark:bg-white dark:text-black dark:hover:bg-slate-200",
  },
  {
    id: "x",
    href: platformUrl("x"),
    label: "X",
    Icon: FaXTwitter,
    className:
      "bg-black text-white hover:bg-neutral-800 shadow-black/30 dark:bg-white dark:text-black dark:hover:bg-slate-200",
  },
  {
    id: "snapchat",
    href: platformUrl("snapchat"),
    label: "Snapchat",
    Icon: FaSnapchat,
    className:
      "bg-yellow-400 text-black hover:bg-yellow-300 shadow-yellow-400/40",
  },
  {
    id: "telegram",
    href: platformUrl("telegram"),
    label: "Telegram",
    Icon: FaTelegram,
    className: "bg-[#229ED9] text-white hover:bg-[#1B8DC1] shadow-[#229ED9]/30",
  },
];

export const FloatingContact = () => {
  return (
    <div
      data-testid="floating-contact"
      dir="ltr"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999] flex flex-row items-center gap-2.5 rounded-full bg-white/80 dark:bg-slate-900/80 backdrop-blur-md border border-slate-200 dark:border-slate-800 p-2 shadow-xl shadow-black/10 print:hidden"
    >
      {socials.map(({ id, href, label, Icon, className }, i) => (
        <motion.a
          key={id}
          data-testid={`fab-${id}`}
          href={href}
          target={id === "email" ? undefined : "_blank"}
          rel={id === "email" ? undefined : "noopener noreferrer"}
          aria-label={label}
          title={label}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35 + i * 0.06 }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.94 }}
          className={`inline-flex h-12 w-12 items-center justify-center rounded-full shadow-lg transition-colors ${className}`}
        >
          <Icon className="h-5 w-5" />
        </motion.a>
      ))}
    </div>
  );
};
